// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';

export const updateMachineStatusListFilterBy = filterBy => ({
    payload: filterBy,
    property: 'filterBy',
    type: actions.UPDATE_TCSM_MACHINE_STATUS_FILTER_BY
});

export const updateMachineStatusListSortBy = sortBy => ({
    payload: sortBy,
    property: 'sortBy',
    type: actions.UPDATE_TCSM_MACHINE_STATUS_SORT_BY
});

export const updateMachineStatusListSortDirection = sortDirection => ({
    payload: sortDirection,
    property: 'sortDirection',
    type: actions.UPDATE_TCSM_MACHINE_STATUS_SORT_DIRECTION
});



// WEBPACK FOOTER //
// ./src/tcsm/wip/action-creators/machine-status-search-filters.js